export const FB_POSTS = [
  {
    id: 'fb1',
    text: '🙏 "Your Kundli is not your fate — it is your cosmic map. Learn to read it, and you will find the right path at every crossroads of life." Schedule your personal reading today and discover the celestial guidance waiting for you. ॐ',
    img: 'https://picsum.photos/seed/fb_post_01/600/340',
    alt: 'Vedic wisdom post',
    likes: '2.4K',
    comments: 138,
    shares: 67,
    date: '2 days ago',
  },
  {
    id: 'fb2',
    text: '💍 Congratulations to the couple whose Kundli Matching we completed this week! Gun Milan showed 32 out of 36 gunas — a truly blessed union. Wishing them a life of harmony, prosperity, and divine love. ॐ शुभ विवाह!',
    img: 'https://picsum.photos/seed/fb_post_02/600/340',
    alt: 'Marriage blessings',
    likes: '3.1K',
    comments: 204,
    shares: 91,
    date: '5 days ago',
  },
  {
    id: 'fb3',
    text: '🪐 Saturn transit update for 2026 — if you have Saturn in the 7th house, this is a period of deep karmic clearing in relationships. Do not resist change; instead, work with it through patience and daily Shani prayer. Message us for a personalized transit report.',
    img: 'https://picsum.photos/seed/fb_post_03/600/340',
    alt: 'Saturn transit 2026',
    likes: '1.9K',
    comments: 176,
    shares: 52,
    date: '1 week ago',
  },
  {
    id: 'fb4',
    text: '💎 New batch of authentic Rudraksha malas and Blue Sapphire rings now available in our Divine Shop. Every gemstone is energised with Vedic mantras before dispatch. Limited stock — DM or visit our shop link to book yours today.',
    img: 'https://picsum.photos/seed/fb_post_04/600/340',
    alt: 'Divine Shop gems',
    likes: '2.7K',
    comments: 149,
    shares: 83,
    date: '10 days ago',
  },
  {
    id: 'fb5',
    text: '📚 New batch of our Online Vedic Astrology Course starts 1st July 2026! Learn birth chart reading, dasha interpretation, and planetary remedies from the comfort of your home. Early bird seats filling fast — enrol now and begin your cosmic journey. ॐ',
    img: 'https://picsum.photos/seed/fb_post_05/600/340',
    alt: 'Astrology course',
    likes: '4.2K',
    comments: 311,
    shares: 127,
    date: '2 weeks ago',
  },
]
